module.exports = __webpack_public_path__ + "static/media/scout_bow.3dc9b305.png";